var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.92 8.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6,8.87H.32A.32.32,0,0,1,0,8.57H0V8.33A.31.31,0,0,1,.32,8H16.6a.31.31,0,0,1,.32.3h0v.24a.32.32,0,0,1-.32.3h0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2.06 8.14 14.86 8.14 14.86 7.35 2.06 7.35 2.06 8.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,1.45V.8A.47.47,0,0,0,9,.38.52.52,0,0,0,8.34,0,.5.5,0,0,0,8,.38.48.48,0,0,0,8.25.8v.65A5.71,5.71,0,0,0,2.58,7V7H14.37V7A5.71,5.71,0,0,0,8.7,1.45"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.721760f60f32effe92cb53e8323e7cf0.svg";
export { ForwardRef as ReactComponent };